import { SupportTicket } from '../models/SupportTicket'
import { feedbackCollection } from './framework/ClientCollections'

// addSupportTicket creates a new ticket document.
export async function addSupportTicket(ticket: Omit<SupportTicket, 'id'>): Promise<SupportTicket> {
  return await feedbackCollection.create(ticket)
}
